var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4796_23216",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4796_23216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 13.3334H10.6667V11.3334C10.6667 10.6 10.4056 9.97226 9.88341 9.45004C9.36119 8.92782 8.73341 8.66671 8.00008 8.66671C7.26675 8.66671 6.63897 8.92782 6.11675 9.45004C5.59453 9.97226 5.33341 10.6 5.33341 11.3334V13.3334ZM8.00008 7.33337C8.73341 7.33337 9.36119 7.07226 9.88341 6.55004C10.4056 6.02782 10.6667 5.40004 10.6667 4.66671V2.66671H5.33341V4.66671C5.33341 5.40004 5.59453 6.02782 6.11675 6.55004C6.63897 7.07226 7.26675 7.33337 8.00008 7.33337ZM2.66675 14.6667V13.3334H4.00008V11.3334C4.00008 10.6556 4.15841 10.0195 4.47508 9.42504C4.79175 8.8306 5.23341 8.3556 5.80008 8.00004C5.23341 7.64449 4.79175 7.16949 4.47508 6.57504C4.15841 5.9806 4.00008 5.34449 4.00008 4.66671V2.66671H2.66675V1.33337H13.3334V2.66671H12.0001V4.66671C12.0001 5.34449 11.8417 5.9806 11.5251 6.57504C11.2084 7.16949 10.7667 7.64449 10.2001 8.00004C10.7667 8.3556 11.2084 8.8306 11.5251 9.42504C11.8417 10.0195 12.0001 10.6556 12.0001 11.3334V13.3334H13.3334V14.6667H2.66675Z",
    fill: "#ED0C2F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.3f296f3a649e8ee388b148f319a34d91.svg";
export { ForwardRef as ReactComponent };